"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Übersichtskarten-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCOverview
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCOverview} options.module Modul-Instanz
 */
gc.gis.module.GCOverview.Panel = function( options )
{
	var self = this;

	gc.gis.assert.isSet( options );
	this.module = options.module;
	this.map_id = options.mapID;

	var options_widget = {
		className: 'gc-overview',
        target: '.gc-gis-main'
	};

    if (options.enableToolbar)
    {
        options_widget.toolbar = {
            containerClassName: 'gc-toolbar',
            items: [
                new gc.gis.widget.GCMenu({
                    label: 'Menü',
                    icon: 'glyphicon glyphicon-menu-hamburger',
                    items: [
	                    [
	                        new gc.gis.widget.GCItem({
	                            label: 'Ausschnitt übernehmen',
	                            click: function () {
	                                self.module.setCurrentExtent();
	                            }
	                        }),
	                        new gc.gis.widget.GCItem({
	                            label: 'Ebenen übernehmen',
	                            click: function () {
	                                self.module.setCurrentLayers();
	                            }
	                        }),
	                        new gc.gis.widget.GCItem({
	                            label: 'Ausschnitt und Ebenen übernehmen',
	                            click: function () {
	                                self.module.setCurrentExtent();
	                                self.module.setCurrentLayers();
	                            }
	                        })
	                    ],
	                    [
		                    new gc.gis.widget.GCItem({
			                    label: 'Zurücksetzen',
			                    click: function () {
				                    self.module.applyLastView();
			                    }
		                    })
	                    ]
                    ]
                })
            ]
        };
    }

    gc.gis.widget.GCPanel.call(this, options_widget);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCOverview);

	this.element = this._render();

	this._initContent();
	// this._initEvents();	// Achtung: wird nicht im Konstruktor aufgerufen!
};
gc.gis.module.GCOverview.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 *
 */
gc.gis.module.GCOverview.Panel.prototype._initContent = function()
{
	var element = jQuery('<div>', {
		'id':    this.map_id,
		'class': 'gc-overview-map'
	});

	this.element_loading = jQuery('<div>', {
		'class': 'loading-indicator',
		html: '<div><span>Lade... </span></div>'
	});

	this.element_content.append( element ).append( this.element_loading );
};

/**
 *
 */
gc.gis.module.GCOverview.Panel.prototype._initEvents = function()
{
	var self = this;

	this.module._overview_map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_STARTED, this, function(evt ) {
		self._updateLoadingStatus();
	});
	this.module._overview_map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ENDED, this, function(evt ) {
		self._updateLoadingStatus();
	});
	this.module._overview_map.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ERROR, this, function(evt ) {
		self._updateLoadingStatus();
	});

	this._updateLoadingStatus();
};

/**
 *
 */
gc.gis.module.GCOverview.Panel.prototype._updateLoadingStatus = function()
{
	var n = this.module._overview_map.getLoadingQueue().length;

	if( n > 0 )
	{
		// this.element_label.text('Lade '+ n +' '+ (n===1?'Element':'Elemente') +'... ');
		if( !this.element_loading.is(':visible') )
		{
			this.element_loading.show();
		}
	}
	else
	{
		this.element_loading.hide();
	}
};
